const SHARE_PREFIX = '/share'
const WIDGET_TOKEN_PARAM = 'widget_token'
const RESET_TOKEN_PARAM = 'token'
const RESET_EMAIL_PARAM = 'email'

/**
 * Маршруты, URL которых сам является секретом: токен доступа к ветпаспорту лежит в пути
 * (`/share/pet/{token}`, `/share/doc/{token}`), подписанный токен виджета и ссылка
 * восстановления пароля — в query. Метрика отправляет URL страницы вместе с хитом,
 * поэтому на таких адресах счётчик молчит.
 */
export function isPrivateAnalyticsLocation(pathname: string, search = ''): boolean {
    if (pathname === SHARE_PREFIX || pathname.startsWith(`${SHARE_PREFIX}/`)) {
        return true
    }

    const query = new URLSearchParams(search)

    return query.has(WIDGET_TOKEN_PARAM) || isPasswordResetQuery(query)
}

/**
 * Пара token+email в адресе — ссылка восстановления пароля (её разбирает app.vue).
 * Значения проверяются на непустоту так же, как у потребителя: пустые параметры
 * восстановление не запускают, и глушить на них счётчик не за чем.
 */
function isPasswordResetQuery(query: URLSearchParams): boolean {
    return Boolean(query.get(RESET_TOKEN_PARAM)) && Boolean(query.get(RESET_EMAIL_PARAM))
}

export function isPrivateAnalyticsHere(): boolean {
    return isPrivateAnalyticsLocation(window.location.pathname, window.location.search)
}

/**
 * Переход с приватной страницы на публичную полноценной навигацией оставляет полный URL
 * в `document.referrer` (same-origin), а Метрика шлёт referrer вместе с первым хитом.
 * Заголовок `Referrer-Policy: no-referrer` на `/share/**` закрывает это на сервере;
 * проверка здесь — второй рубеж на случай, когда referrer всё же дошёл.
 */
export function cameFromPrivateAnalyticsRoute(): boolean {
    const referrer = document.referrer
    if (!referrer) {
        return false
    }

    try {
        const url = new URL(referrer)
        if (url.origin !== window.location.origin) {
            return false
        }

        return isPrivateAnalyticsLocation(url.pathname, url.search)
    } catch {
        return false
    }
}
